import React, { useState, useEffect, useRef } from 'react';
import { ConstructorEventUpdateSQLStatus } from '../../../../Event/event';

const Level3 = () => {
  const [score, setScore] = useState(0);
  const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);
  const [feedback, setFeedback] = useState('');
  const [feedbackColor, setFeedbackColor] = useState('');
  const [confettiElements, setConfettiElements] = useState([]);
  const [timeLeft, setTimeLeft] = useState(45);
  const timerRef = useRef(null);
  const inputRef = useRef(null); 

  const correctSound = useRef(new Audio("https://www.orangefreesounds.com/wp-content/uploads/2014/11/ding.mp3"));
  const wrongSound = useRef(new Audio("https://www.orangefreesounds.com/wp-content/uploads/2014/08/Wrong-answer-sound-effect.mp3"));

  const questions = [
    { "q": "What is 1/3 of 9?", "a": 3 },
    { "q": "What is 3/5 of 15?", "a": 9 },
    { "q": "Convert 0.25 to a fraction", "a": "1/4" },
    { "q": "What is 50% of 60?", "a": 30 },
    { "q": "Is 9 prime or composite?", "a": "Composite" },
    { "q": "Estimate ₹672 – ₹279", "a": "393" },
    { "q": "You get 25% off ₹200. How much is the discount?", "a": "50" },
    { "q": "Is 27 divisible by 9?", "a": "Yes" },
    { "q": "Estimate ₹572 – ₹270", "a": "302"  },
    { "q": "What is 2/3 of 9?", "a": 6 },
    { "q": "Which is greater: 0.7 or 2/3?", "a": "2/3" },
    { "q": "Is 5 prime or composite?", "a": "Prime" },
    { "q": "₹198 + ₹98 Estimate?", "a": "296" },
    { "q": "What is 10% of 120?", "a": 12 },
    { "q": "Convert 0.5 to a fraction", "a": "1/2" }
  ];

  const normalizeAnswer = (input) => input.trim().toLowerCase().replace(/\s+/g, '');

  const moveToNextQuestion = () => {
    setCurrentQuestionIndex((prev) => prev + 1);
    setFeedback('');
    setTimeLeft(45);
  };

  const checkAnswer = (e) => {
    e.preventDefault();
    clearInterval(timerRef.current);

    const userAnswerRaw = e.target.answer.value;
    inputRef.current.value = ''; 
    inputRef.current.focus();

    const correctAnswer = questions[currentQuestionIndex].a;
    let isCorrect = false;

    if (typeof correctAnswer === 'number') {
      isCorrect = Number(userAnswerRaw) === correctAnswer;
    } else {
      isCorrect = normalizeAnswer(userAnswerRaw) === normalizeAnswer(correctAnswer);
    }

    if (isCorrect) {
      correctSound.current.currentTime = 0;
      correctSound.current.play();
      setScore((prev) => prev + 1);
      setFeedback('🎉 Correct!');
      setFeedbackColor('#2e7d32');
      showConfetti();
    } else {
      wrongSound.current.currentTime = 0;
      wrongSound.current.play();
      setFeedback(`❌ Wrong! The correct answer is: ${correctAnswer}`);
      setFeedbackColor('#c62828');
    }

    setTimeout(() => {
      moveToNextQuestion();
    }, 1500);
  };

  const showConfetti = () => {
    const elements = [];
    for (let i = 0; i < 30; i++) {
      elements.push(
        <div
          key={i + Math.random()}
          style={{
            position: 'fixed',
            width: '10px',
            height: '10px',
            backgroundColor: `hsl(${Math.floor(Math.random() * 360)}, 70%, 60%)`,
            opacity: 0.8,
            pointerEvents: 'none',
            animation: `fall ${2 + Math.random() * 2}s linear forwards`,
            left: Math.random() * window.innerWidth + 'px'
          }}
        ></div>
      );
    }
    setConfettiElements(elements);
    setTimeout(() => setConfettiElements([]), 3000);
  };

  // Timer logic
  useEffect(() => {
    if (!questions[currentQuestionIndex]) return;
    timerRef.current = setInterval(() => {
      setTimeLeft((prev) => {
        if (prev <= 1) {
          clearInterval(timerRef.current);
          wrongSound.current.currentTime = 0;
          wrongSound.current.play();
          setFeedback(`⏰ Time's up! The correct answer was: ${questions[currentQuestionIndex].a}`);
          setFeedbackColor('#c62828');
          setTimeout(() => {
            moveToNextQuestion();
          }, 1500);
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(timerRef.current);
  }, [currentQuestionIndex]);

  const question = questions[currentQuestionIndex];

          useEffect(() => {
          if (currentQuestionIndex === questions.length) {
            const responsedata = ConstructorEventUpdateSQLStatus();
            console.log("Event completed", responsedata);
          }
        }, [currentQuestionIndex]);

  return (
    <div style={{
      fontFamily: 'Poppins, sans-serif',
      backgroundImage: 'url("https://as2.ftcdn.net/jpg/04/61/65/03/1000_F_461650383_vOTkFxYQ2T2kvuymieHDHbIWjghyL3DY.jpg")',
      backgroundSize: 'cover',
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'center',
      minHeight: '100vh',
      overflowX: 'hidden',
      padding: '1rem'
    }}>
      {confettiElements}
      <div style={{ display: 'grid', placeItems: 'center', minHeight: '100vh' }}>
        <div style={{
          background: '#fff',
          border: '3px solid #4a148c',
          borderRadius: '30px',
          padding: '5vw',
          maxWidth: '500px',
          width: '100%',
          textAlign: 'center'
        }}>
          <h2 style={{
            fontSize: '1.8rem',
            color: '#4a148c',
            fontFamily: 'Comic Neue, cursive',
            textShadow: '1px 1px 3px #b39ddb'
          }}>
            Score → <span>{score}</span>
          </h2>
          <h3 style={{ fontSize: '1.2rem', margin: '20px 0 30px', minHeight: '3em' }}>
            {question ? question.q : `🎉 Quiz Complete! Your final score is ${score} / ${questions.length}`}
          </h3>

          {question && (
            <form onSubmit={checkAnswer} style={{ display: 'flex', flexDirection: 'column', gap: '1.5rem' }}>
              <input
                ref={inputRef} 
                name="answer"
                type="text"
                required
                autoComplete="off"
                inputMode="numeric"
                style={{
                  fontSize: '1.2rem',
                  padding: '1rem',
                  border: '2px solid #4a148c',
                  borderRadius: '15px',
                  textAlign: 'center'
                }}
              />
              <button
                type="submit"
                style={{
                  padding: '1rem',
                  backgroundColor: '#4a148c',
                  color: '#fff',
                  fontSize: '1.4rem',
                  fontWeight: 700,
                  border: 'none',
                  borderRadius: '15px',
                  cursor: 'pointer'
                }}
              >
                Submit
              </button>
              <div style={{ fontSize: '1.5rem', color: '#4a148c', fontWeight: 'bold' }}>
                ⏳ Time Left: {timeLeft}s
              </div>
            </form>
          )}

          <div style={{
            fontSize: '1rem',
            marginTop: '15px',
            height: '30px',
            fontWeight: 700,
            fontFamily: 'Comic Neue, cursive',
            color: feedbackColor
          }}>
            {feedback}
          </div>
        </div>
      </div>

      <style>{`
        @keyframes fall {
          0% { transform: translateY(0) rotate(0deg); opacity: 1; }
          100% { transform: translateY(600px) rotate(360deg); opacity: 0; }
        }
      `}</style>
    </div>
  );
};

export default Level3;
